module.exports = __webpack_public_path__ + "static/media/4552.f17979ad.jpg";